import { ref, watch, computed, nextTick, getCurrentInstance } from 'vue';
import { useJumpToFirstError } from '../../../common/js/composables/jump-to-first-error';

const REQUEST_STATES = {
	INITIAL: 'INITIAL',
	LOADING: 'LOADING',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR'
};

export const useCaptcha = (init, key = 'captchaKey', fragment = 'htmlFragment') => {
	const { jumpToFirstError } = useJumpToFirstError(getCurrentInstance());
	const requestState = ref(REQUEST_STATES.INITIAL);
	const captchaKey = ref(null);
	const captchaImg = ref(null);
	const captchaError = ref(false);
	const captchaNonce = ref(0);
	const getCaptcha = async () => {
		try {
			requestState.value = REQUEST_STATES.LOADING;
			captchaKey.value = null;
			captchaImg.value = null;
			const { data } = await init();
			captchaKey.value = data[key];
			captchaImg.value = data[fragment];
			requestState.value = REQUEST_STATES.INITIAL;
			captchaNonce.value += 1;
		} catch (err) {
			requestState.value = REQUEST_STATES.TECHNICAL_ERROR;
		}
	};
	const resetCaptchaError = () => {
		captchaError.value = false;
	};

	watch(captchaError, (val) => {
		if (val) {
			getCaptcha();
		}
	});
	watch(captchaImg, async (value) => {
		if (value && captchaError.value) {
			await nextTick();
			jumpToFirstError();
		}
	});

	const technicalError = computed(() => requestState.value == REQUEST_STATES.TECHNICAL_ERROR);
	const loading = computed(() => requestState.value == REQUEST_STATES.LOADING);

	return {
		captchaError,
		technicalError,
		captchaImg,
		captchaKey,
		captchaNonce,
		loading,
		getCaptcha,
		resetCaptchaError
	};
};
